import { render, staticRenderFns } from "./ProjectPixConfigList.vue?vue&type=template&id=05d6e6a4&scoped=true"
import script from "./ProjectPixConfigList.vue?vue&type=script&lang=js"
export * from "./ProjectPixConfigList.vue?vue&type=script&lang=js"
import style0 from "./ProjectPixConfigList.vue?vue&type=style&index=0&id=05d6e6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6e6a4",
  null
  
)

export default component.exports